// extracted by mini-css-extract-plugin
export default {"activeDogTag":"ActiveDoll_activeDogTag","component":"ActiveDoll_component","colorizable":"ActiveDoll_colorizable","background":"ActiveDoll_background"};